/** ## Stats Controller
 *
 * @module src/controllers/stats
 */

"use strict";

const reportlist = require("../../components/reportlist");
const notification = require("../../components/notification");
const block = require("../../components/block");
const modal = require("../../components/modal");
const conf = require("../../config");
const l = require("../../common").localization;
const moment = require("moment-timezone");
const ChartjsNode = require("chart.js");

const avgAdjustedTurn = (loc, activity) => {
  let runningTime = 0;
  for (let i = 0; i < activity.length; ++i) {
    let sizeIndex = Math.ceil(parseInt(activity[i].size, 10) / 2) - 1;
    if (sizeIndex > 6) {
      sizeIndex = 6;
    } else if (sizeIndex < 0) {
      sizeIndex = 0;
    }
    let checkTime =
      (activity[i].statusTimes.closed -
        activity[i].statusTimes.seated -
        loc.turnTimes[sizeIndex].turnTime * 60) /
      60;
    if (checkTime < 5) {
      checkTime = 5;
    }
    runningTime += checkTime;
  }
  let finalTime = Math.round(runningTime / (activity.length + 1));
  if (finalTime < 10) {
    finalTime = 10;
  } else if (finalTime > 150) {
    finalTime = 150;
  }
  return finalTime;
};

const getTurnIndex = (turnTimes, adjusted) => {
  if (adjusted < 0) {
    adjusted = 5;
  } else if (adjusted > 150) {
    adjusted = 150;
  }
  for (let i = 0; i < turnTimes.length; ++i) {
    if (turnTimes[i].value >= adjusted) {
      return turnTimes[i].value;
    }
  }
};

const turnSuggest = (kd) => {
  const loc = kd.doc("location")[0];
  if (
    loc.hasOwnProperty("suggestTurn") &&
    loc.suggestTurn &&
    !conf.vars.hasOwnProperty("suggestTurnSession")
  ) {
    const cutoff = parseInt(Date.now() / 1000, 10) - 60 * 60 * 1; // 1 hour
    const activity = kd.where("activity", (obj) => {
      if (
        obj.status === 5 &&
        obj.statusTimes.closed > cutoff &&
        obj.statusTimes.closed - obj.statusTimes.seated > 60 * 2
      ) {
        // 2 minutes
        return true;
      }
    });
    if (activity.length >= 4) {
      // not active until 5 parties have data
      const adjusted = avgAdjustedTurn(loc, activity);
      const turnTime = getTurnIndex(conf.vars.turnTimes, adjusted);
      if (Math.abs(loc.baseTurn - turnTime) >= 5) {
        // create notification to change turn (or not)
        const opt2 = {
          width: "90%",
          type: "dialog",
          h1: l.translate("Adjust Turn Time Suggestion"),
          body: `${l.translate(
            "Guest List suggests the 4-top turn time could be" +
              " adjusted from"
          )} ${loc.baseTurn} ${l.translate("minutes")} ${l.translate(
            "to"
          )} ${turnTime} \
    ${l.translate("minutes")} ${l.translate(
            "in order to give better wait time and table turn" + " estimates."
          )}`,
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "cancel",
            },
            {
              description: l.translate("Stop asking (this session)"),
              value: "stop",
            },
            {
              description: l.translate("Change this for me"),
              value: "change",
            },
          ],
        };

        modal.create(opt2, {}, (err, value) => {
          modal.destroy();
          if (value.button === "change") {
            const proposed = {
              domain: "location",
              _id: loc._id,
              baseTurn: turnTime,
            };
            kd.update(proposed)
              .then((result) => {})
              .catch((err2) => {
                console.log("err2", err2);
              });
          } else if (value.button === "stop") {
            conf.vars.suggestTurnSession = true;
          }
        });
      }
    }
  }
};

const header = (kd) => {
  let parties = 0;
  let covers = 0;
  const activity = kd.where("activity", (obj) => {
    if (
      obj.status === 1 ||
      obj.status === 2 ||
      obj.status === 3 ||
      obj.status === 5 ||
      obj.status === 7
    ) {
      return true;
    }
  });
  for (let i = 0; i < activity.length; ++i) {
    ++parties;
    covers += activity[i].size;
  }
  $("#daily_covers").html(covers);
  $("#daily_parties").html(parties);
  if (kd.usage === "standard" || kd.usage === "resume") {
    turnSuggest(kd);
  }
};

/** Init
 */
const init = (kd) => {
  kd.on("activity.update", () => {
    header(kd);
  });
  header(kd);
  $("#inventory_chart_title_wide").html(
    l.translate("Please choose an option from the left hand menu")
  );
  let opt = {
    kd,
    targetDiv: "stats_avg",
    static: true,
  };

  let data = {
    type: "stats",
    domain: "activity",
    mode: "avg",
    switch: "hour",
    h1: l.translate("Average Wait Times"),
    h2: "...",
    waitSize: 2,
    expand: true,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  opt = {
    kd,
    targetDiv: "statst_avg",
    static: true,
  };

  data = {
    type: "stats",
    domain: "activity",
    mode: "avg",
    switch: "today",
    h1: l.translate("Average Wait Times"),
    h2: "...",
    waitSize: 2,
    expand: true,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  // 3-4 standard

  opt = {
    kd,
    targetDiv: "stats_turn",
    static: true,
  };

  data = {
    type: "stats",
    domain: "activity",
    mode: "turn",
    switch: "hour",
    h1: l.translate("Average Turn Times"),
    h2: "...",
    waitSize: 4,
    expand: false,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 3,
      max: 4,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  opt = {
    kd,
    targetDiv: "statst_turn",
    static: true,
  };

  data = {
    type: "stats",
    domain: "activity",
    mode: "turn",
    switch: "today",
    h1: l.translate("Average Turn Times"),
    h2: "...",
    waitSize: 4,
    expand: false,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 3,
      max: 4,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  // 5-6 standard

  opt = {
    kd,
    targetDiv: "stats_server",
    static: true,
  };

  data = {
    type: "stats",
    domain: "activity",
    mode: "server",
    switch: "hour",
    h1: l.translate("Server Performance"),
    h2: "...",
    waitSize: 6,
    expand: false,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 5,
      max: 6,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  opt = {
    kd,
    targetDiv: "statst_server",
    static: true,
  };

  data = {
    type: "stats",
    domain: "activity",
    mode: "server",
    switch: "today",
    h1: l.translate("Server Performance"),
    h2: "...",
    waitSize: 6,
    expand: false,
    single: true,
    group: "stats",
    refresh: 30,
    height: {
      min: 0,
      max: 300,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 5,
      max: 6,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {});

  kd.on("activity.update", () => {
    setTimeout(() => {
      renderSummary(kd);
    }, 300);
  });

  renderSummary(kd);

  const buttons = [
    {
      description: l.translate("Wait vs. Quoted Times"),
      value: "wait",
    },
    {
      description: l.translate("Average Turn Time"),
      value: "turn",
    },
    {
      description: l.translate("Server Turn Times"),
      value: "server",
    },
    {
      description: l.translate("Server Cover Count"),
      value: "cover",
    },
    {
      description: l.translate("Server Party Count"),
      value: "party",
    },
  ];

  const options = {
    target_id: "content_wide_report_list",
    type: "reportlist",
    position: "left",
    highlight: null,
    adjust: {
      x: 0,
      y: 25,
    },
  };

  reportlist.create(options, buttons, (err2, value) => {
    switch (value.value) {
      case "wait": {
        renderWaitChart(kd);
        break;
      }
      case "turn": {
        renderTurnChart(kd);
        break;
      }
      case "server": {
        renderServerTurnChart(kd);
        break;
      }
      case "cover": {
        renderServerCoverChart(kd);
        break;
      }
      case "party": {
        renderServerPartyChart(kd);
        break;
      }
      default: {
        break;
      }
    }
  });
  $("#reportlistback").off();
  $("#reportlistback").fastClick((e) => {
    $("#layout_sidebar_header_expand").click();
  });
};

const renderWaitChart = (kd) => {
  const data = getWaitFull(kd, 8);
  $("#inventory_chart_title_wide").html(
    l.translate("Wait Times vs. Quoted Times last 8 hours")
  );
  const ctx = document
    .getElementById("content_wide_report_view")
    .getContext("2d");
  const opt = {
    type: "line",
    data: {
      labels: data.labels,
      datasets: [
        {
          data: data.quoted,
          label: l.translate("Quoted Minutes"),
          borderColor: "#0cdff7",
          fill: "origin",
        },
        {
          data: data.waited,
          label: l.translate("Waited Minutes"),
          borderColor: "#ff9014",
          fill: "origin",
        },
      ],
    },
    options: {
      legend: {
        position: "bottom",
        labels: {
          fontColor: "#fff",
        },
      },
      title: {
        display: false,
        fontColor: "#fff",
        text: "Inventory",
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              fontColor: "#aaa",
              color: "#999",
            },
            gridLines: {
              display: true,
              color: "#666",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              fontColor: "#ddd",
              color: "#999",
            },
            gridLines: {
              display: true,
              color: "#666",
            },
          },
        ],
      },
    },
  };
  if (conf.vars.NODE_ENV.indexOf("android") > -1) {
    opt.options.legend.onClick = (e) => {
      e.stopPropagation();
    };
  }
  const myChart = new ChartjsNode(ctx, opt);
};

const renderTurnChart = (kd) => {
  const data = getTurnFull(kd, 8);
  $("#inventory_chart_title_wide").html(
    l.translate("Average Table Turn Time last 8 hours")
  );
  const ctx = document
    .getElementById("content_wide_report_view")
    .getContext("2d");
  const opt = {
    type: "line",
    data: {
      labels: data.labels,
      datasets: [
        {
          data: data.turned,
          label: l.translate("Turn Time in Minutes"),
          borderColor: "#9dff47",
          fill: "origin",
        },
      ],
    },
    options: {
      legend: {
        position: "bottom",
        labels: {
          fontColor: "#fff",
        },
      },
      title: {
        display: false,
        fontColor: "#fff",
        text: "Inventory",
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              fontColor: "#aaa",
              color: "#999",
            },
            gridLines: {
              display: true,
              color: "#666",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              fontColor: "#ddd",
              color: "#999",
            },
            gridLines: {
              display: true,
              color: "#666",
            },
          },
        ],
      },
    },
  };
  if (conf.vars.NODE_ENV.indexOf("android") > -1) {
    opt.options.legend.onClick = (e) => {
      e.stopPropagation();
    };
  }
  const myChart = new ChartjsNode(ctx, opt);
};

const renderServerTurnChart = (kd) => {
  const data = getServersTurnFull(kd, 8);
  if (!data.length) {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 3,
      h1: l.translate("Not enough data to render"),
      body: l.translate("Please seat and clear tables to see this chart."),
      buttons: [
        {
          description: "ok",
          value: "close",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      notification.destroy();
    });
  } else {
    const datasets = [];
    for (let i = 0; i < data.length; ++i) {
      if (!isNaN(data[i].server)) {
        data[i].server = `${l.translate("Unassigned Section")} (${
          data[i].server
        })`;
      }
      datasets[i] = {
        data: data[i].turned,
        label: data[i].server,
        borderColor: data[i].color,
        fill: "origin",
      };
    }

    $("#inventory_chart_title_wide").html(
      l.translate("Server Turn Times last 8 hours")
    );
    const ctx = document
      .getElementById("content_wide_report_view")
      .getContext("2d");
    const opt = {
      type: "line",
      data: {
        labels: data[0].labels,
        datasets,
      },
      options: {
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#fff",
          },
        },
        title: {
          display: false,
          fontColor: "#fff",
          text: "Inventory",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#aaa",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "#ddd",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
        },
      },
    };
    if (conf.vars.NODE_ENV.indexOf("android") > -1) {
      opt.options.legend.onClick = (e) => {
        e.stopPropagation();
      };
    }
    const myChart = new ChartjsNode(ctx, opt);
  }
};

const renderServerCoverChart = (kd) => {
  const data = getServersCoverFull(kd, 8);
  const datasets = [];
  if (!data.length) {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 3,
      h1: l.translate("Not enough data to render"),
      body: l.translate("Please seat and clear tables to see this chart."),
      buttons: [
        {
          description: "ok",
          value: "close",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      notification.destroy();
    });
  } else {
    for (let i = 0; i < data.length; ++i) {
      if (!isNaN(data[i].server)) {
        data[i].server = `${l.translate("Unassigned Section")} (${
          data[i].server
        })`;
      }
      datasets[i] = {
        data: data[i].covers,
        label: data[i].server,
        borderColor: data[i].color,
        fill: "origin",
      };
    }
    $("#inventory_chart_title_wide").html(
      l.translate("Server Cover Count last 8 hours")
    );
    const ctx = document
      .getElementById("content_wide_report_view")
      .getContext("2d");
    const opt = {
      type: "line",
      data: {
        labels: data[0].labels,
        datasets,
      },
      options: {
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#fff",
          },
        },
        title: {
          display: false,
          fontColor: "#fff",
          text: "Inventory",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#aaa",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "#ddd",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
        },
      },
    };
    if (conf.vars.NODE_ENV.indexOf("android") > -1) {
      opt.options.legend.onClick = (e) => {
        e.stopPropagation();
      };
    }
    const myChart = new ChartjsNode(ctx, opt);
  }
};

const renderServerPartyChart = (kd) => {
  const data = getServersPartyFull(kd, 8);
  const datasets = [];
  if (!data.length) {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 3,
      h1: l.translate("Not enough data to render"),
      body: l.translate("Please seat and clear tables to see this chart."),
      buttons: [
        {
          description: "ok",
          value: "close",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      notification.destroy();
    });
  } else {
    for (let i = 0; i < data.length; ++i) {
      if (!isNaN(data[i].server)) {
        data[i].server = `${l.translate("Unassigned Section")} (${
          data[i].server
        })`;
      }
      datasets[i] = {
        data: data[i].parties,
        label: data[i].server,
        borderColor: data[i].color,
        fill: "origin",
      };
    }

    $("#inventory_chart_title_wide").html(
      l.translate("Server Party Count last 8 hours")
    );
    const ctx = document
      .getElementById("content_wide_report_view")
      .getContext("2d");
    const opt = {
      type: "line",
      data: {
        labels: data[0].labels,
        datasets,
      },
      options: {
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#fff",
          },
        },
        title: {
          display: false,
          fontColor: "#fff",
          text: "Inventory",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#aaa",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "#ddd",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
        },
      },
    };
    if (conf.vars.NODE_ENV.indexOf("android") > -1) {
      opt.options.legend.onClick = (e) => {
        e.stopPropagation();
      };
    }
    const myChart = new ChartjsNode(ctx, opt);
  }
};

const renderSummary = (kd) => {
  const stats = getStatsSummary(kd);
  for (let i = 2; i <= 16; i = i + 2) {
    const quoteHour = stats.avg.hour[`s${i}`].quoted;
    const waitHour = stats.avg.hour[`s${i}`].waited;
    $(`#stats_avg_hour_${i}_1`).html(`${i - 1}-${i}`);
    if (isNaN(stats.avg.hour[`s${i}`].quoted)) {
      $(`#stats_avg_hour_${i}_2`).html("--");
    } else {
      $(`#stats_avg_hour_${i}_2`).html(`${stats.avg.hour[`s${i}`].quoted}m`);
    }
    if (isNaN(stats.avg.hour[`s${i}`].waited)) {
      $(`#stats_avg_hour_${i}_3`).html("--");
    } else {
      $(`#stats_avg_hour_${i}_3`).html(`${stats.avg.hour[`s${i}`].waited}m`);
    }

    $(`#stats_avg_today_${i}_1`).html(`${i - 1}-${i}`);
    if (isNaN(stats.avg.today[`s${i}`].quoted)) {
      $(`#stats_avg_today_${i}_2`).html("--");
    } else {
      $(`#stats_avg_today_${i}_2`).html(`${stats.avg.today[`s${i}`].quoted}m`);
    }
    if (isNaN(stats.avg.today[`s${i}`].waited)) {
      $(`#stats_avg_today_${i}_3`).html("--");
    } else {
      $(`#stats_avg_today_${i}_3`).html(`${stats.avg.today[`s${i}`].waited}m`);
    }

    $(`#stats_turn_hour_${i}_1`).html(`${i - 1}-${i}`);
    if (isNaN(stats.turn.hour[`s${i}`].turn)) {
      $(`#stats_turn_hour_${i}_2`).html("--");
    } else {
      $(`#stats_turn_hour_${i}_2`).html(`${stats.turn.hour[`s${i}`].turn}m`);
    }

    $(`#stats_turn_today_${i}_1`).html(`${i - 1}-${i}`);
    if (isNaN(stats.turn.today[`s${i}`].turn)) {
      $(`#stats_turn_today_${i}_2`).html("--");
    } else {
      $(`#stats_turn_today_${i}_2`).html(`${stats.turn.today[`s${i}`].turn}m`);
    }
  }

  let thisHTML = "";
  for (let i = 0; i < stats.server.hour.length; ++i) {
    thisHTML += `<div class="stats_field_left">${stats.server.hour[i].server}</div>`;
    thisHTML += `<div class="stats_field">${stats.server.hour[i].turn}m</div>`;
    thisHTML += `<div class="stats_field">${stats.server.hour[i].guests}</div>`;
  }
  $("#stats_server_hour_box").html(thisHTML);

  thisHTML = "";
  for (let i = 0; i < stats.server.today.length; ++i) {
    thisHTML += `<div class="stats_field_left">${stats.server.today[i].server}</div>`;
    thisHTML += `<div class="stats_field">${stats.server.today[i].turn}m</div>`;
    thisHTML += `<div class="stats_field">${stats.server.today[i].guests}</div>`;
  }
  $("#stats_server_today_box").html(thisHTML);
};

const getAvg = (kd, cutoff) => {
  const avg = {};
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("added") &&
      obj.statusTimes.added > cutoff &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > 0
    ) {
      return true;
    }
  });

  for (let size = 2; size <= 16; size = size + 2) {
    const thisActivity = [];
    for (let i = 0; i < rawactivity.length; ++i) {
      if (rawactivity[i].size == size || rawactivity[i].size == size - 1) {
        thisActivity.push(rawactivity[i]);
      }
    }

    let waited = 0;
    let quoted = 0;
    for (let i = 0; i < thisActivity.length; ++i) {
      waited =
        waited +
        (thisActivity[i].statusTimes.seated -
          thisActivity[i].statusTimes.added);
      quoted = quoted + thisActivity[i].quoted;
    }
    avg[`s${size}`] = {};
    if (thisActivity.length) {
      avg[`s${size}`].quoted = Math.round(quoted / thisActivity.length);
      avg[`s${size}`].waited = Math.round(waited / thisActivity.length / 60);
    } else {
      avg[`s${size}`].quoted = Math.round(quoted / 1);
      avg[`s${size}`].waited = Math.round(waited / 1 / 60);
    }
  }
  return avg;
};

const getTurn = (kd, cutoff) => {
  const avg = {};
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff &&
      obj.statusTimes.hasOwnProperty("closed") &&
      obj.statusTimes.closed > 0
    ) {
      return true;
    }
  });

  const servers = [];
  for (let size = 2; size <= 16; size = size + 2) {
    const thisActivity = [];
    for (let i = 0; i < rawactivity.length; ++i) {
      if (rawactivity[i].size == size || rawactivity[i].size == size - 1) {
        thisActivity.push(rawactivity[i]);
      }
    }

    let seated = 0;
    for (let i = 0; i < thisActivity.length; ++i) {
      seated =
        seated +
        (thisActivity[i].statusTimes.closed -
          thisActivity[i].statusTimes.seated) /
          60;
    }
    avg[`s${size}`] = {};
    avg[`s${size}`].turn = Math.round(seated / thisActivity.length);
  }

  return avg;
};

const getServers = (kd, cutoff) => {
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff &&
      obj.statusTimes.hasOwnProperty("closed") &&
      obj.statusTimes.closed > 0
    ) {
      return true;
    }
  });

  const servers = [];

  const thisActivity = rawactivity;
  for (let i = 0; i < thisActivity.length; ++i) {
    if (
      thisActivity[i].hasOwnProperty("server") &&
      thisActivity[i].server !== ""
    ) {
      let match = false;
      for (let s = 0; s < servers.length; ++s) {
        if (servers[s].server === thisActivity[i].server) {
          match = true;
          servers[s].turn =
            servers[s].turn +
            (thisActivity[i].statusTimes.closed -
              thisActivity[i].statusTimes.seated) /
              60;
          servers[s].guests =
            parseInt(servers[s].guests, 10) +
            parseInt(thisActivity[i].size, 10);
          ++servers[s].parties;
        }
      }
      if (!match) {
        servers.push({
          server: thisActivity[i].server,
          turn:
            (thisActivity[i].statusTimes.closed -
              thisActivity[i].statusTimes.seated) /
            60,
          guests: parseInt(thisActivity[i].size, 10),
          parties: 1,
        });
      }
    }
  }
  for (let s = 0; s < servers.length; ++s) {
    servers[s].turn = Math.round(servers[s].turn / servers[s].parties);
  }

  return servers;
};

const getStatsSummary = (kd) => {
  const grid = {
    avg: {
      hour: [],
      today: [],
    },
    turn: {
      hour: [],
      today: [],
    },
    server: {
      hour: [],
      today: [],
    },
  };
  const cutoffhour = parseInt(moment().format("X"), 10) - 60 * 60 * 1;
  const cutofftoday = parseInt(moment().format("X"), 10) - 60 * 60 * 18;
  grid.avg.hour = getAvg(kd, cutoffhour);
  grid.avg.today = getAvg(kd, cutofftoday);
  grid.turn.hour = getTurn(kd, cutoffhour);
  grid.turn.today = getTurn(kd, cutofftoday);
  grid.server.hour = getServers(kd, cutoffhour);
  grid.server.today = getServers(kd, cutofftoday);
  return grid;
};

const getWaitFull = (kd, hours) => {
  const wait = {};
  const cutoff = parseInt(
    moment().startOf("hour").subtract(hours, "hours").format("X"),
    10
  );
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("added") &&
      obj.statusTimes.added > cutoff &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > 0
    ) {
      return true;
    }
  });
  wait.quoted = [];
  wait.waited = [];
  wait.labels = [];
  for (let hour = 0; hour < hours; ++hour) {
    const thisActivity = [];
    const thisHour = parseInt(
      moment().startOf("hour").subtract(hour, "hours").format("X"),
      10
    );
    wait.labels[hour] = moment(thisHour * 1000).format(l.translate("h:mm a"));
    const nextHour = thisHour + 60 * 60;
    for (let i = 0; i < rawactivity.length; ++i) {
      if (
        rawactivity[i].statusTimes.added >= thisHour &&
        rawactivity[i].statusTimes.added < nextHour
      ) {
        thisActivity.push(rawactivity[i]);
      }
    }
    let waited = 0;
    let quoted = 0;
    for (let i = 0; i < thisActivity.length; ++i) {
      waited =
        waited +
        (thisActivity[i].statusTimes.seated -
          thisActivity[i].statusTimes.added);
      quoted = quoted + thisActivity[i].quoted;
    }
    wait.quoted[hour] = Math.round(quoted / thisActivity.length);
    wait.waited[hour] = Math.round(waited / thisActivity.length / 60);
    if (isNaN(wait.quoted[hour])) {
      wait.quoted[hour] = 0;
    }
    if (isNaN(wait.waited[hour])) {
      wait.waited[hour] = 0;
    }
  }
  wait.quoted.reverse();
  wait.waited.reverse();
  wait.labels.reverse();
  return wait;
};

const getTurnFull = (kd, hours) => {
  const turn = {};
  const cutoff = parseInt(
    moment().startOf("hour").subtract(hours, "hours").format("X"),
    10
  );
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff &&
      obj.statusTimes.hasOwnProperty("closed") &&
      obj.statusTimes.closed > 0
    ) {
      return true;
    }
  });
  turn.turned = [];
  turn.labels = [];
  for (let hour = 0; hour < hours; ++hour) {
    const thisActivity = [];
    const thisHour = parseInt(
      moment().startOf("hour").subtract(hour, "hours").format("X"),
      10
    );
    turn.labels[hour] = moment(thisHour * 1000).format(l.translate("h:mm a"));
    const nextHour = thisHour + 60 * 60;
    for (let i = 0; i < rawactivity.length; ++i) {
      if (
        rawactivity[i].statusTimes.seated >= thisHour &&
        rawactivity[i].statusTimes.seated < nextHour
      ) {
        thisActivity.push(rawactivity[i]);
      }
    }
    let turned = 0;
    for (let i = 0; i < thisActivity.length; ++i) {
      turned =
        turned +
        (thisActivity[i].statusTimes.closed -
          thisActivity[i].statusTimes.seated);
    }
    turn.turned[hour] = Math.round(turned / thisActivity.length / 60);
    if (isNaN(turn.turned[hour])) {
      turn.turned[hour] = 0;
    }
  }
  turn.turned.reverse();
  turn.labels.reverse();
  return turn;
};

const getServersTurnFull = (kd, hours) => {
  const cutoff = parseInt(
    moment().startOf("hour").subtract(hours, "hours").format("X"),
    10
  );
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff &&
      obj.statusTimes.hasOwnProperty("closed") &&
      obj.statusTimes.closed > 0
    ) {
      return true;
    }
  });

  const servers = [];

  for (let i = 0; i < rawactivity.length; ++i) {
    if (
      rawactivity[i].hasOwnProperty("server") &&
      rawactivity[i].server !== ""
    ) {
      let match = false;
      for (let s = 0; s < servers.length; ++s) {
        if (servers[s].server === rawactivity[i].server) {
          match = true;
        }
      }
      if (!match) {
        servers.push({
          server: rawactivity[i].server,
        });
      }
    }
  }

  for (let i = 0; i < servers.length; ++i) {
    const serverActivity = kd.where("activity", (obj) => {
      if (
        obj.hasOwnProperty("statusTimes") &&
        obj.statusTimes.hasOwnProperty("seated") &&
        obj.statusTimes.seated > cutoff &&
        obj.statusTimes.hasOwnProperty("closed") &&
        obj.statusTimes.closed > 0 &&
        obj.server === servers[i].server
      ) {
        return true;
      }
    });
    servers[i].turned = [];
    servers[i].section = [];
    servers[i].labels = [];
    for (let hour = 0; hour < hours; ++hour) {
      const thisServerActivity = [];
      const thisHour = parseInt(
        moment().startOf("hour").subtract(hour, "hours").format("X"),
        10
      );
      servers[i].labels[hour] = moment(thisHour * 1000).format(
        l.translate("h:mm a")
      );
      const nextHour = thisHour + 60 * 60;
      for (let t = 0; t < serverActivity.length; ++t) {
        if (
          serverActivity[t].statusTimes.seated >= thisHour &&
          serverActivity[t].statusTimes.seated < nextHour
        ) {
          thisServerActivity.push(serverActivity[t]);
        }
      }
      let turned = 0;
      for (let r = 0; r < thisServerActivity.length; ++r) {
        turned =
          turned +
          (thisServerActivity[r].statusTimes.closed -
            thisServerActivity[r].statusTimes.seated);
        servers[i].section = thisServerActivity[r].section;
        servers[i].color =
          conf.vars.sections[thisServerActivity[r].section].color;
      }
      servers[i].turned[hour] = Math.round(
        turned / thisServerActivity.length / 60
      );
      if (isNaN(servers[i].turned[hour])) {
        servers[i].turned[hour] = 0;
      }
    }
    servers[i].turned.reverse();
    servers[i].labels.reverse();
  }
  return servers;
};

const getServersCoverFull = (kd, hours) => {
  const cutoff = parseInt(
    moment().startOf("hour").subtract(hours, "hours").format("X"),
    10
  );
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff
    ) {
      return true;
    }
  });

  const servers = [];

  for (let i = 0; i < rawactivity.length; ++i) {
    if (
      rawactivity[i].hasOwnProperty("server") &&
      rawactivity[i].server !== ""
    ) {
      let match = false;
      for (let s = 0; s < servers.length; ++s) {
        if (servers[s].server === rawactivity[i].server) {
          match = true;
        }
      }
      if (!match) {
        servers.push({
          server: rawactivity[i].server,
        });
      }
    }
  }

  for (let i = 0; i < servers.length; ++i) {
    const serverActivity = kd.where("activity", (obj) => {
      if (
        obj.hasOwnProperty("statusTimes") &&
        obj.statusTimes.hasOwnProperty("seated") &&
        obj.statusTimes.seated > cutoff &&
        obj.server === servers[i].server
      ) {
        return true;
      }
    });
    servers[i].covers = [];
    servers[i].section = [];
    servers[i].labels = [];
    for (let hour = 0; hour < hours; ++hour) {
      const thisServerActivity = [];
      const thisHour = parseInt(
        moment().startOf("hour").subtract(hour, "hours").format("X"),
        10
      );
      servers[i].labels[hour] = moment(thisHour * 1000).format(
        l.translate("h:mm a")
      );
      const nextHour = thisHour + 60 * 60;
      for (let t = 0; t < serverActivity.length; ++t) {
        if (
          serverActivity[t].statusTimes.seated >= thisHour &&
          serverActivity[t].statusTimes.seated < nextHour
        ) {
          thisServerActivity.push(serverActivity[t]);
        }
      }
      let covers = 0;
      for (let r = 0; r < thisServerActivity.length; ++r) {
        covers = covers + thisServerActivity[r].size;
        servers[i].section = thisServerActivity[r].section;
        servers[i].color =
          conf.vars.sections[thisServerActivity[r].section].color;
      }
      servers[i].covers[hour] = covers;
      if (isNaN(servers[i].covers[hour])) {
        servers[i].covers[hour] = 0;
      }
    }
    servers[i].covers.reverse();
    servers[i].labels.reverse();
  }

  return servers;
};

const getServersPartyFull = (kd, hours) => {
  const cutoff = parseInt(
    moment().startOf("hour").subtract(hours, "hours").format("X"),
    10
  );
  const rawactivity = kd.where("activity", (obj) => {
    if (
      obj.hasOwnProperty("statusTimes") &&
      obj.statusTimes.hasOwnProperty("seated") &&
      obj.statusTimes.seated > cutoff
    ) {
      return true;
    }
  });

  const servers = [];

  for (let i = 0; i < rawactivity.length; ++i) {
    if (
      rawactivity[i].hasOwnProperty("server") &&
      rawactivity[i].server !== ""
    ) {
      let match = false;
      for (let s = 0; s < servers.length; ++s) {
        if (servers[s].server === rawactivity[i].server) {
          match = true;
        }
      }
      if (!match) {
        servers.push({
          server: rawactivity[i].server,
        });
      }
    }
  }

  for (let i = 0; i < servers.length; ++i) {
    const serverActivity = kd.where("activity", (obj) => {
      if (
        obj.hasOwnProperty("statusTimes") &&
        obj.statusTimes.hasOwnProperty("seated") &&
        obj.statusTimes.seated > cutoff &&
        obj.server === servers[i].server
      ) {
        return true;
      }
    });
    servers[i].parties = [];
    servers[i].section = [];
    servers[i].labels = [];
    for (let hour = 0; hour < hours; ++hour) {
      const thisServerActivity = [];
      const thisHour = parseInt(
        moment().startOf("hour").subtract(hour, "hours").format("X"),
        10
      );
      servers[i].labels[hour] = moment(thisHour * 1000).format(
        l.translate("h:mm a")
      );
      const nextHour = thisHour + 60 * 60;
      for (let t = 0; t < serverActivity.length; ++t) {
        if (
          serverActivity[t].statusTimes.seated >= thisHour &&
          serverActivity[t].statusTimes.seated < nextHour
        ) {
          thisServerActivity.push(serverActivity[t]);
        }
      }
      let parties = 0;
      for (let r = 0; r < thisServerActivity.length; ++r) {
        ++parties;
        servers[i].section = thisServerActivity[r].section;
        servers[i].color =
          conf.vars.sections[thisServerActivity[r].section].color;
      }
      servers[i].parties[hour] = parties;
      if (isNaN(servers[i].parties[hour])) {
        servers[i].parties[hour] = 0;
      }
    }
    servers[i].parties.reverse();
    servers[i].labels.reverse();
  }

  return servers;
};

module.exports = {
  init,
  getStatsSummary,
  getServers,
  getAvg,
  getTurn,
  getWaitFull,
  getTurnFull,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/stats/index.js
 **/